<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="search-types-container">
    <div class="title-wrap">
      <span>{{ $t('type_content') }}</span>
    </div>
    <div class="op-wrap">
      <div
        v-for="tipus in orderedTypes"
        :key="tipus.type"
        class="op-container"
        :class="querySourceFilters.indexOf(tipus.type) !== -1 && 'active'"
        @click="lateralFilterChange(tipus.type, 'source')"
      >
        <ItemIcon
          :type="tipus.type"
          size="xxsm"
          :filled="false"
          class="item-icon"
          :class="querySourceFilters.indexOf(tipus.type) !== -1 && 'active'"
        />
        <span>{{ $t(tipus.type) }}</span>
        <span class="icon-spacer" />
      </div>
    </div>
  </div>
</template>

<script>
import ItemIcon from '../ItemIcon.vue'
export default {
  name: 'TypeFilter',
  components: { ItemIcon },
  props: {},
  data() {
    return {}
  },
  computed: {
    orderedTypes() {
      let trueOrder = ['STATISTICS', 'MICRODATA', 'DATASTORIES', 'SURVEY', 'DOCS', 'MAPS']
      let copyArr = [...this.$getTypesOfContent.data]
      let endArr = []
      trueOrder.forEach(el => {
        let target = copyArr.find(elem => elem.type === el)
        if (target) endArr.push(target)
      })
      return endArr
    },
    querySourceFilters() {
      let arrayWords = []
      if (this.$route.query.source) {
        arrayWords = this.$route.query.source.split(',')
      }
      return arrayWords
    },
  },
  methods: {
    lateralFilterChange(filtVal, filtType) {
      let currentSourceFilters = [...this.querySourceFilters]
      if (this.querySourceFilters.indexOf(filtVal) === -1) {
        currentSourceFilters.push(filtVal)
      } else {
        currentSourceFilters.splice(this.querySourceFilters.indexOf(filtVal), 1)
      }
      this.$emit('lateral-filter-change', currentSourceFilters, filtType)
    },
  },
}
</script>

<style lang="stylus" scoped>
  .search-types-container
    display: flex
    flex-direction: column
    .title-wrap
      margin-bottom: vw(10px)
      span
        m-font-size(14, 20)
        color: $grey
        font-weight: 400
    .op-wrap
      border-bottom: 1px solid $grey-grey
      display: flex
      flex-wrap: wrap
      gap: vw(10px)
      margin-bottom: vw(15px)
      padding-bottom: vw(20px)
      width: 100%
    .op-container
      m-font-size(14, 20)
      align-items: center
      border: 1px solid $corporate_color_light
      border-radius: vw(25px)
      color: $grey-dark
      cursor: pointer
      display: flex
      font-weight: 400
      gap: vw(5px)
      justify-content: center
      padding: vw(8px) vw(10px)
      &:hover
        background-color: $very-light-grey
        color: #000
        .item-icon
          opacity: 1
      &.active
        background-color: $lighter-blue
        border: 1px solid $corporate_color
        color: $corporate_color
        &:hover
          background-color: $lighter-blue
      .item-icon
        flex-shrink: 0
        opacity: 0
        transition: opacity 0.15s ease-in-out
        width: vw(18px)
        &.active
          opacity: 1
      .icon-spacer
        flex-shrink: 0
        width: 0
        margin-left: vw(18px)
        transition: width 0.15s ease-in-out
</style>
